/**
 * Select field can have the following rules, which affect style and functionality (admin app):
 * - RequiredIf - set * after the label
 * - EnableIf - set both input field and label to disabled, when False
 * - ReadOnlyIf - set both input field and label to readOnly
 */

import { Component, ViewEncapsulation, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';

import { selectMessagesForOpenedEditorForProperty } from 'src/app/project/store/project-data/project-data.selectors';
import type { TreeEntity } from '../../../core/models/entity.model';
import { EntityPropertyBaseComponent } from '../entity-property-base/entity-property-base.component';
import type { FormControlOptions } from '@angular/forms';
import type { MeasurementUnit } from '../../../core/models/measurement-unit.model';
import { selectMeasurementUnit } from '../../../core/store/measurement-units/measurement-units.selector';

@Component({
  selector: 'app-entity-property-select',
  templateUrl: './entity-property-select.component.html',
  styleUrls: ['./entity-property-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EntityPropertySelectComponent extends EntityPropertyBaseComponent<string | number> implements OnInit, OnChanges {
  messages: TreeEntity[] = [];

  messagesForOpenedEditorForProperty$ = (key: string) => this.store.select(selectMessagesForOpenedEditorForProperty(key, this.entityId));

  measurementUnit$: Observable<MeasurementUnit>;

  constructor(private store: Store) {
    super();
    this.messagesForOpenedEditorForProperty$ = (propertyKey: string) =>
      this.store.select(selectMessagesForOpenedEditorForProperty(this.property.Key, this.entityId)).pipe(take(1));
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes['property']) {
      this.measurementUnit$ = this.store.select(selectMeasurementUnit(this.property.MeasurementUnit?.Key));
      this.messagesForOpenedEditorForProperty$(this.property.Key)
        .pipe(take(1))
        .subscribe(msgs => (this.messages = msgs));
    }
  }

  orderTranslate = false;

  ngOnInit() {
    // Checks if select property has orderTranslate metadata set to true
    const metaDataOrderTranslate = this.propertyType.MetaData['OrderTranslate'];
    if (metaDataOrderTranslate !== undefined && metaDataOrderTranslate) {
      this.orderTranslate = true;
    }
  }

  override getFormControlOptions(): FormControlOptions {
    return { updateOn: 'change' };
  }
}
